export class ContentAirportLookup {
  label: string;
  originLabel: string;
  destinationLabel: string;
  cityOrAirport: string;
  fullAirportList: string;
  lookupLabel: string;
  countryLabel: string;
  countries: string;
  usAndCanada: string;
  usCanadaProvince: string;
  alphabeticallyLabel: string;
  airportsLabel: string;
  search: any;
  savedSearch: any;
  recentSearch: any;
  odPairRestriction = '';
  isInterceptModalRequired = '';

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['originLabel']) {
        this.originLabel = contentjson['originLabel'];
      }
      if (contentjson['destinationLabel']) {
        this.destinationLabel = contentjson['destinationLabel'];
      }
      if (contentjson['cityOrAirport']) {
        this.cityOrAirport = contentjson['cityOrAirport'];
      }
      if (contentjson['fullAirportList']) {
        this.fullAirportList = contentjson['fullAirportList'];
      }
      if (contentjson['lookupLabel']) {
        this.lookupLabel = contentjson['lookupLabel'];
      }
      if (contentjson['countryLabel']) {
        this.countryLabel = contentjson['countryLabel'];
      }
      if (contentjson['countries']) {
        this.countries = contentjson['countries'];
      }
      if (contentjson['usAndCanada']) {
        this.usAndCanada = contentjson['usAndCanada'];
      }
      if (contentjson['usCanadaProvince']) {
        this.usCanadaProvince = contentjson['usCanadaProvince'];
      }
      if (contentjson['alphabeticallyLabel']) {
        this.alphabeticallyLabel = contentjson['alphabeticallyLabel'];
      }
      if (contentjson['airportsLabel']) {
        this.airportsLabel = contentjson['airportsLabel'];
      }
      if (contentjson['recentSearch']) {
        this.recentSearch = contentjson['recentSearch'];
      }
      if (contentjson['savedSearch']) {
        this.savedSearch = contentjson['savedSearch'];
      }
      if (contentjson['search']) {
        this.search = contentjson['search'];
      }
      if (contentjson['odPairRestriction']) {
        this.odPairRestriction = contentjson['odPairRestriction'];
      } else {
        this.odPairRestriction = 'false';
      }
      if (contentjson['isInterceptModalRequired']) {
        this.isInterceptModalRequired = contentjson['isInterceptModalRequired'];
      }
    }
  }
}
